import Toast, { type ToastContainerOptions } from 'vue3-toastify'
import 'vue3-toastify/dist/index.css'

export const toastOptions: ToastContainerOptions = {
  autoClose: 4000,
  position: 'top-right',
  hideProgressBar: true,
  theme: 'auto',
}

export { Toast }
